import { keys, mergeDeepRight, pipe, prop, reduce } from "ramda";

import type { Theme } from "./theme";
import theme from "./theme";

type ScaleFunc = (props: { theme: Theme }) => {
  fontSize: string;
  lineHeight: number;
};

export type ScaleKeys = keyof Theme["typography"];

type TypeScale = {
  [key in ScaleKeys]: ScaleFunc;
};

const mapSizeToKey = (key: string) => (props: { theme: Theme }) =>
  prop<ScaleKeys, Theme["typography"]>(key as ScaleKeys, props.theme.typography);
const getFnFromKey = (key: string) => ({ [key]: mapSizeToKey(key) });
const merge = (scale: Partial<TypeScale>, key: string) => mergeDeepRight(scale, getFnFromKey(key));

const createTypeScaleFromTheme = pipe(prop("typography")<Theme>, keys, reduce<string, Partial<TypeScale>>(merge, {}));

export const typeScale = createTypeScaleFromTheme(theme) as TypeScale;
